<template>
  <div class="SerialTable">
    <el-dialog
      title="数量"
      width="922px"
      append-to-body
      :visible.sync="visible"
      @open="open"
      @close="clearData"
      :show="show"
      :close-on-click-modal="false"
    >
      <div style="height: 300px">
        <div
          class="SerialTable_boxs SerialTable_box"
          id="key_content"
          ref="key_content"
        >
          <div v-if="!checked" class="inputserial MaInputg">
            <el-input
              id="inputserialn_3"
              ref="inputserialn_3"
              size="mini"
              class="sty_colls"
              v-model="serialnumber"
              @focus="doFocu"
              @blur="doBlur"
              @keyup.enter.native="enterkeyxlh(1, 1, true, tableDataxlh)"
            >
              <span slot="prefix" class="label_sty">录入 :</span>
            </el-input>
          </div>
          <div v-if="checked" class="inputserial MaInputg">
            <el-input
              id="inputserialn_1"
              ref="inputserialn_1"
              size="mini"
              class="sty_colls"
              v-model="serialnumberrise"
              @focus="doFocu"
              @blur="doBlur"
              @keyup.down.native="enterkeyxlh(1, 0, false)"
              @keyup.up.prevent.native="upkeyxlh(1, 0, false)"
              @keyup.enter.native="enterkeyxlh(1, 0, false)"
            >
              <span slot="prefix" class="label_sty">起 :</span>
            </el-input>
            <el-input
              id="inputserialn_2"
              ref="inputserialn_2"
              size="mini"
              class="sty_colls"
              v-model="serialnumberstop"
              @focus="doFocu"
              @blur="doBlur"
              @keyup.down.native="enterkeyxlh(1, 1, true)"
              @keyup.up.prevent.native="upkeyxlh(1, 1, true)"
              @keyup.enter.native="enterkeyxlh(1, 1, true)"
            >
              <span slot="prefix" class="label_sty">止 :</span>
            </el-input>
          </div>
          <div class="sty_collsb">
            <div>
              <el-button
                size="mini"
                style="margin-right: 10px"
                @click="downlclick"
                >下载序列号模板</el-button
              >
            </div>
            <!-- <el-button size="mini">导入序列号</el-button> -->
            <el-upload
              style="border: none; padding: 0"
              :action="
                'http://118.190.210.223:8090/index/Export_Excel/ImportSerialNo?' +
                'jparams=' +
                JSON.stringify(jparam)
              "
              :on-success="handleAvatarSuccess"
              accept="xls/xlsx"
              :show-file-list="false"
              :disabled="$attrs.pargam.Documenttype != 0 ? false : true"
            >
              <el-button
                size="mini"
                :disabled="$attrs.pargam.Documenttype != 0 ? false : true"
                >导入序列号</el-button
              >
            </el-upload>
          </div>
        </div>
        <div>
          <vxe-table
            border
            height="180px"
            ref="xTable"
            highlight-hover-row
            highlight-current-row
            :data="tableDataxlh"
            @select-change="selectChangeEvent"
            @select-all="selectAllEvent"
            @cell-dblclick="dbclick"
            @header-cell-click="headercellclick"
            :header-cell-style="{
              background: '#eef1f6',
              color: '#000',
              fontSize: '16px',
              height: '37px',
              padding: '0',
              fontWeight: 'bold',
            }"
            :footer-row-style="{
              background: '#eef1f6',
              color: '#000',
              fontSize: '14px',
              height: '30px',
              padding: '0',
            }"
            :footer-cell-style="{
              background: '#fff',
              color: '#000',
              fontSize: '14px',
              height: '30px',
              padding: '0',
            }"
          >
            <vxe-table-column
              type="index"
              align="center"
              width="60"
              fixed="left"
            >
              <template v-slot:header>
                <span>行号</span>
              </template>
              <template v-slot="{ column, rowIndex }">{{
                rowIndex + 1
              }}</template>
            </vxe-table-column>
            <template v-for="(item, index) in ObtainHeaderxlh">
              <vxe-table-column
                :key="index"
                :field="item.Key"
                :title="item.Rename"
                align="center"
                v-if="item.Key != 'Show'"
              >
                <template v-slot="{ row, rowIndex }">
                  <div class="input_box ub ub-ac">
                    <input
                      v-if="item.Key != 'sn'"
                      ref="Serialfocusxlh"
                      :id="'x_' + rowIndex + '_y_' + index"
                      v-model.lazy="row[item.Key]"
                      class="input_stt"
                      @keyup.up="UpArrows(row, rowIndex, index)"
                      @keyup.enter="DwArrows(row, rowIndex, index)"
                      @keyup.down="downArrows(row, rowIndex, index)"
                      @blur="changeData(row, index, item.Key, row[item.Key])"
                      @focus="doFocu"
                    />
                    <div v-else class="only_show_div">{{ row[item.Key] }}</div>
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                width="60"
                :key="index"
                :field="item.Key"
                :title="item.Rename"
                align="center"
                fixed="left"
                v-else-if="$attrs.pargam.Documenttype != 1"
              >
                <template v-slot:header>
                  <div class="input_box ub ub-ac">
                    <el-checkbox
                      v-model="modeltrue"
                      @change="checkboxshow"
                    ></el-checkbox>
                  </div>
                </template>
                <template v-slot="{ row }">
                  <div class="input_box ub ub-ac">
                    <el-checkbox v-model="row.Show"></el-checkbox>
                  </div>
                </template>
              </vxe-table-column>
            </template>
            <vxe-table-column
              width="100"
              align="center"
              title="操作"
              fixed="left"
              v-if="$attrs.pargam.Documenttype != 0"
            >
              <template v-slot="{ row, rowIndex }">
                <el-button
                  type="text"
                  @click.native.prevent="deleteRow(rowIndex)"
                  >移除</el-button
                >
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div class="btnnimiserials">
          <div style="display: flex; justify-content: space-between; margin: 0">
            <p style="line-height: 32px; margin-right: 10px">
              <el-checkbox
                style="margin: 0 0 0 24px"
                v-model="checked"
                @change="changechecked"
                :disabled="$attrs.pargam.Model != 'TakeStock' ? false : true"
                >批量录入</el-checkbox
              >
            </p>
            <!-- :disabled="$attrs.pargam.Documenttype==1?false:true" -->
            <vxe-button
              v-if="$attrs.pargam.Documenttype != 0"
              @click="removeSelecteds"
              >删除全部</vxe-button
            >
          </div>
          <div>
            <el-button size="mini" type="primary" @click="clickDetermine"
              >确定</el-button
            >
            <el-button size="mini" @click="$emit('update:show', false)"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>  

<script>
// 工具库
import tool from "@/utils/tool"; //本地缓存存取
import { locale } from "moment";

export default {
  data() {
    return {
      jparam: {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
      },
      modeltrue: false,
      multipleSelection: [], // 多选数据
      serialnumber: "", // 序列号单选
      serialnumberrise: "", // 序列号多选 起
      serialnumberstop: "", // 序列号多选 止
      checked: false, // 是否批量录入
      Total: "", // 合计
      tableDatarow: {}, // 数量当前数据
      itemKey: "",
      ObtainHeaderxlh: [
        { Key: "Show", Rename: "选择" },
        { Key: "sn", Rename: "序列号" },
        { Key: "Color", Rename: "颜色" },
        { Key: "Memo", Rename: "备注" },
      ], // 多单位 表头
      SerialNotemporaryj: [],
      tableDataxlh: [],
      tableDataxlh2: [],
      FullName: "", //当前商品名
      UnitName: "", // 当前单位
      vchtypes: this.vchtype, // 判断显示弹框类型
      visible: this.show, //是否显示选择弹出框
    };
  },
  props: {
    vchtype: Number,
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show;
    },
    visible: {
      handler(val, l) {
        if (val) {
          this.tableDataxlh = this.$attrs.tableDatasl;
          setTimeout(() => {
            this.$refs.xTable.updateData();
            this.$refs.xTable.updateFooter();
          }, 300);
        } else {
          this.modeltrue = false;
          this.serialnumber = ""; // 序列号单选
          this.serialnumberrise = ""; // 序列号多选 起
          this.serialnumberstop = ""; // 序列号多选 止
        }
      },
    },
  },

  methods: {
    open() {
      this.$refs.xTable.recalculate();
    },
    // 删除全部
    removeSelecteds() {
      this.tableDataxlh = [];
    },
    // 删除
    deleteRow(index) {
      // this.tableDat = tableDat;
      this.tableDataxlh.splice(index, 1);
    },
    // 文件上传成功时的钩子
    handleAvatarSuccess(res, file) {
      if (res.status == 0) {
        let ary = [];
        if (this.tableDataxlh.length === 0) {
          this.tableDataxlh.push(...res.data);
          tool.popMessage(this, res.description, "success");
        } else {
          res.data.forEach((item, index) => {});
          //临时数组存放
          var tempArray1 = []; //临时数组1 // 用于存放原始数组中的序列号
          var tempArray2 = []; //临时数组2 // 用于存放导入数组中 不与原始数组中的元素相等的元素
          for (var i = 0; i < this.tableDataxlh.length; i++) {
            tempArray1[this.tableDataxlh[i].sn] = true; //将数this.tableDataxlh 中的元素值作为tempArray1 中的键，值为true;
          }
          for (var i = 0; i < res.data.length; i++) {
            if (!tempArray1[res.data[i].sn]) {
              tempArray2.push(res.data[i]); //过滤array1 中与this.tableDataxlh 相同的元素;
            }
          }
          this.tableDataxlh.push(...tempArray2);
          tool.popMessage(
            this,
            "导入序列号成功，成功数量" + tempArray2.length,
            "success"
          );
        }
      } else {
        tool.popMessage(this, res.description, "warning");
      }
    },
    // 下载示例
    downlclick() {
      tool.Download("ImportSerialNo");
    },
    // 是否全选
    checkboxshow(val) {
      if (val) {
        this.tableDataxlh.map((item) => {
          item.Show = val;
        });
      } else {
        this.tableDataxlh.map((item) => {
          item.Show = val;
        });
      }
    },
    // 多选
    selectChangeEvent({ selection }) {
      this.multipleSelection = selection;
    },
    selectAllEvent({ selection }) {
      this.multipleSelection = selection;
    },
    // 点击头部
    headercellclick() {},
    // 双击行
    dbclick(row) {
      if (this.$attrs.pargam.Documenttype != 1) {
        let _this = this;
        setTimeout(() => {
          _this.$emit("chooseBack", [row.row], this.vchtype);
          _this.$emit("update:show", false);
        }, 100);
      }
    },
    // 批量录入按钮
    changechecked(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.inputserialn_1.focus();
        }, 200);
      } else {
        setTimeout(() => {
          this.$refs.inputserialn_3.focus();
        }, 200);
      }
    },
    // 聚焦
    doFocus() {},
    // 失焦
    doBlur() {},
    // 上键
    upkeyxlh(index) {
      this.$refs.inputserialn_1.focus();
    },
    // 判断数据是否重复
    isAllEqual(array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== array[0];
        });
      } else {
        return true;
      }
    },
    // 回车
    enterkeyxlh(index, rowIndex, type, data_) {
      if (type) {
        if (this.checked) {
          if (this.serialnumberrise != "" && this.serialnumberstop != "") {
            let re = /([0-9]+)$/i;
            let rise = this.serialnumberrise.match(re)[0];
            let stop = this.serialnumberstop.match(re)[0];
            if (
              this.getLength(this.serialnumberrise) ===
              this.getLength(this.serialnumberstop)
            ) {
              if (
                this.serialnumberrise.split(rise)[0] ===
                  this.serialnumberstop.split(stop)[0] &&
                this.serialnumberrise.split(rise)[0] != "" &&
                this.serialnumberstop.split(stop)[0] != ""
              ) {
                let res = /^0*/;
                let rises = rise.match(res)[0];
                let stops = stop.match(res)[0];
                if (
                  Number(
                    this.serialnumberrise.split(
                      this.serialnumberrise.split(rise)[0]
                    )[1]
                  ) <=
                  Number(
                    this.serialnumberstop.split(
                      this.serialnumberstop.split(stop)[0]
                    )[1]
                  )
                ) {
                  let a = {
                    prefix: this.serialnumberrise.split(rise)[0],
                    Suffix: Number(
                      this.serialnumberrise.split(
                        this.serialnumberrise.split(rise)[0]
                      )[1]
                    ),
                  };
                  let b = {
                    prefix: this.serialnumberstop.split(stop)[0],
                    Suffix: Number(
                      this.serialnumberstop.split(
                        this.serialnumberstop.split(stop)[0]
                      )[1]
                    ),
                  };
                  this.AddNumber(
                    a,
                    b,
                    this.getLength(this.serialnumberrise),
                    1
                  );
                } else {
                  tool.popMessage(this, "序列号格式不正确", "warning");
                }
              } else if (
                this.serialnumberrise.split(rise)[0] ===
                  this.serialnumberstop.split(stop)[0] &&
                this.serialnumberrise.split(rise)[0] == "" &&
                this.serialnumberstop.split(stop)[0] == ""
              ) {
                if (
                  Number(this.serialnumberrise) <= Number(this.serialnumberstop)
                ) {
                  let a = {
                    prefix: "",
                    Suffix: Number(this.serialnumberrise),
                  };
                  let b = {
                    prefix: "",
                    Suffix: Number(this.serialnumberstop),
                  };
                  this.AddNumber(
                    a,
                    b,
                    this.getLength(this.serialnumberrise),
                    2
                  );
                } else {
                  tool.popMessage(this, "序列号格式不正确", "warning");
                }
              } else {
                tool.popMessage(this, "序列号格式不正确", "warning");
              }
            } else {
              tool.popMessage(this, "序列号格式不正确", "warning");
            }
          } else {
            tool.popMessage(this, "序列号不能为空", "warning");
          }
        } else if (!this.checked) {
          if (this.serialnumber != "") {
            if (this.$attrs.pargam.Documenttype == 1) {
              this.tableDataxlh2.push(this.serialnumber);
              if (this.tableDataxlh.length === 0) {
                this.tableDataxlh.push({
                  sn: this.serialnumber,
                  Color: "",
                  BaseNo: "",
                  Memo: "",
                  Show: true,
                });
              } else {
                let asdf = [];
                this.tableDataxlh.forEach((item) => {
                  if (item.sn == this.serialnumber) {
                    asdf.push(true);
                  } else {
                    asdf.push(false);
                  }
                });
                if (this.isAllEqual(asdf)) {
                  this.tableDataxlh.push({
                    sn: this.serialnumber,
                    Color: "",
                    BaseNo: "",
                    Memo: "",
                    Show: true,
                  });
                }
              }
              this.serialnumber = "";
            }
            // 销售 模块
            if (this.$attrs.pargam.Documenttype == 0) {
              // 循环
              if (data_.length > 0) {
                for (let index = 0; index < data_.length; index++) {
                  const element = data_[index];
                  // 存在序列号  选中
                  if (data_[index].sn == this.serialnumber) {
                    data_[index].Show = true;
                    this.serialnumber = "";
                    break;
                    // 不存在 如果是盘点单新增  否则就提示不存在
                  } else if (data_.length - 1 == index) {
                    if (this.$attrs.pargam.Model == "TakeStock") {
                      this.$confirm(
                        "当前序列号不存在是否需要新增到序列号列表中？",
                        "确认提示",
                        {
                          confirmButtonText: "确定",
                          cancelButtonText: "取消",
                          type: "warning",
                        }
                      )
                        .then(() => {
                          this.tableDataxlh.push({
                            sn: this.serialnumber,
                            Color: "",
                            BaseNo: "",
                            Memo: "",
                            Show: true,
                          });
                          this.serialnumber = "";
                        })
                        .catch(() => {
                          tool.popMessage(this, "已取消新增", "info");
                        });
                      break;
                    } else {
                      tool.popMessage(this, "序列号不存在", "warning");
                      this.serialnumber = "";
                    }
                  }
                }
              } else {
                if (this.$attrs.pargam.Model == "TakeStock") {
                  this.$confirm(
                    "当前序列号不存在是否需要新增到序列号列表中？",
                    "确认提示",
                    {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning",
                    }
                  )
                    .then(() => {
                      this.tableDataxlh.push({
                        sn: this.serialnumber,
                        Color: "",
                        BaseNo: "",
                        Memo: "",
                        Show: true,
                      });
                      this.serialnumber = "";
                    })
                    .catch(() => {
                      tool.popMessage(this, "已取消新增", "info");
                    });
                }
              }
            }
          } else {
            tool.popMessage(this, "序列号不能为空", "warning");
          }
        }
      } else {
        if (index == 1) {
          this.$refs.inputserialn_2.focus();
        }
        // if (rowIndex == 2 || rowIndex == 1) {
        //   console.log("我是最后一个输入框");
        // }
      }
    },
    // 添加序列号
    AddNumber(rise, stop, lgh, rowIndex) {
      if (this.$attrs.pargam.Documenttype == 1) {
        let add = "0";
        if (rowIndex == 1) {
          let size = this.getLength(rise.prefix);
          for (let index = rise.Suffix; index <= stop.Suffix; index++) {
            if (this.getLength(String(index)) + size < lgh && size != 0) {
              let s = "";
              for (
                let i = Number(this.getLength(String(index))) + size;
                i < Number(lgh);
                i++
              ) {
                s = "0" + s;
              }
              // 判断 tableDataxlh 中是否有数据
              if (this.tableDataxlh.length === 0) {
                this.tableDataxlh.push({
                  BaseNo: "",
                  sn: String(rise.prefix + s + index),
                  Color: "",
                  Memo: "",
                  Show: true,
                });
              } else {
                let asdf = [];
                // 如果出现重复放一个true到asdf中 反之放入false 在判断数组是否全等
                this.tableDataxlh.forEach((item) => {
                  if (String(item.sn) == String(rise.prefix + s + index)) {
                    asdf.push(true);
                  } else {
                    asdf.push(false);
                  }
                });
                if (this.isAllEqual(asdf)) {
                  this.tableDataxlh.push({
                    BaseNo: "",
                    sn: String(rise.prefix + s + index),
                    Color: "",
                    Memo: "",
                    Show: true,
                  });
                }
              }
            } else {
              // 判断 tableDataxlh 中是否有数据
              if (this.tableDataxlh.length === 0) {
                this.tableDataxlh.push({
                  sn: String(rise.prefix + index),
                  Color: "",
                  BaseNo: "",
                  Memo: "",
                  Show: true,
                });
              } else {
                let asdf = [];
                // 如果出现重复放一个true到asdf中 反之放入false 在判断数组是否全等
                this.tableDataxlh.forEach((item) => {
                  if (String(item.sn) == String(rise.prefix + index)) {
                    asdf.push(true);
                  } else {
                    asdf.push(false);
                  }
                });
                if (this.isAllEqual(asdf)) {
                  this.tableDataxlh.push({
                    sn: String(rise.prefix + index),
                    Color: "",
                    BaseNo: "",
                    Memo: "",
                    Show: true,
                  });
                }
              }
            }
          }
        } else if (rowIndex == 2) {
          for (let index = rise.Suffix; index <= stop.Suffix; index++) {
            if (this.getLength(String(index)) < lgh) {
              let s = "" + index;
              for (
                let i = Number(this.getLength(String(index)));
                i < Number(lgh);
                i++
              ) {
                s = "0" + s;
              }
              // 判断 tableDataxlh 中是否有数据
              if (this.tableDataxlh.length === 0) {
                this.tableDataxlh.push({
                  sn: String(s),
                  Color: "",
                  BaseNo: "",
                  Memo: "",
                  Show: true,
                });
              } else {
                let asdf = [];
                // 如果出现重复放一个true到asdf中 反之放入false 在判断数组是否全等
                this.tableDataxlh.forEach((item) => {
                  if (String(item.sn) == String(s)) {
                    asdf.push(true);
                  } else {
                    asdf.push(false);
                  }
                });
                if (this.isAllEqual(asdf)) {
                  this.tableDataxlh.push({
                    sn: String(s),
                    Color: "",
                    BaseNo: "",
                    Memo: "",
                    Show: true,
                  });
                }
              }
            } else {
              // 判断 tableDataxlh 中是否有数据
              if (this.tableDataxlh.length === 0) {
                this.tableDataxlh.push({
                  sn: String(index),
                  BaseNo: "",
                  Color: "",
                  Memo: "",
                  Show: true,
                });
              } else {
                let asdf = [];
                // 如果出现重复放一个true到asdf中 反之放入false 在判断数组是否全等
                this.tableDataxlh.forEach((item) => {
                  if (String(item.sn) == String(index)) {
                    asdf.push(true);
                  } else {
                    asdf.push(false);
                  }
                });
                if (this.isAllEqual(asdf)) {
                  this.tableDataxlh.push({
                    sn: String(index),
                    BaseNo: "",
                    Color: "",
                    Memo: "",
                    Show: true,
                  });
                }
              }
            }
          }
        }
      }
      let dafaf = "";
      if (this.$attrs.pargam.Documenttype == 0) {
        // 若果不是盘点单直接选中输序列号  否则就新增
        if (this.$attrs.pargam.Model != "TakeStock") {
          let size = this.getLength(rise.prefix);
          for (let index = rise.Suffix; index <= stop.Suffix; index++) {
            // if (this.getLength(String(index)) + size < lgh && size != 0) {
            let s = "";
            for (
              let i = Number(this.getLength(String(index))) + size;
              i < Number(lgh);
              i++
            ) {
              s = "0" + s;
            }
            dafaf = String(rise.prefix + s + index);
            this.tableDataxlh.map((item) => {
              if (String(item.sn) == String(dafaf)) {
                item.Show = true;
              }
            });
          }
        } else {
          // 批量录入序列号新增
        }
      }
      this.serialnumber = ""; // 序列号单选
      this.serialnumberrise = ""; // 序列号多选 起
      this.serialnumberstop = ""; // 序列号多选 止
    },
    // 获取字符串长度
    getLength(val) {
      var str = new String(val);
      var bytesCount = 0;
      for (var i = 0, n = str.length; i < n; i++) {
        var c = str.charCodeAt(i);
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          bytesCount += 1;
        } else {
          bytesCount += 2;
        }
      }
      return bytesCount;
    },
    // 序列号单选数据回填
    dateChange(data, v) {
      this[v] = data[0];
    },
    // 换算合计
    changeData(data, index, field, name, vctype) {
      // console.log(data, index, field, name, vctype);
      // let obj = [];
      // let objg = "";
      // for (let index = 0; index < this.tableDatasl.length; index++) {
      //   const element = this.tableDatasl[index];
      //   obj.push({ Qty: Number(element.Percent) * Number(element.Qty) });
      // }
      // this.Total = this.sum(obj, "Qty"); // Number(item.sl);
    },
    sum(data, e) {
      let d = 0;
      data.map((item) => {
        if (item.Qty != "") {
          d += Number(item[e]);
        }
      });
      return Number(d).toFixed(tool.getLocal("get_config").moneyPoint);
    },
    // 聚焦
    doFocu(event, val, Key) {
      event.currentTarget.select();
    },
    // 确定按钮
    clickDetermine() {
      let data = [];
      if (this.$attrs.pargam.Documenttype == 1) {
        this.$emit("chooseBack", this.tableDataxlh, this.vchtype, this.Total);
        this.$emit("update:show", false);
      } else {
        this.tableDataxlh.map((item) => {
          if (item.Show == true) {
            data.push(item);
          }
        });
        this.$emit("chooseBack", data, this.vchtype, this.Total);
        this.$emit("update:show", false);
      }
    },
    distinctObj(numberArr, ind) {
      let obj = "";
      for (var i of numberArr) {
        if (i.id == ind) {
          obj = i;
          return obj;
        }
      }
      return false;
    },
    // 上键
    UpArrows(row, rowIndex, index) {
      rowIndex = rowIndex - 1;
      if (
        this.distinctObj(
          this.$refs.Serialfocusxlh,
          `x_${rowIndex}_y_${index}`
        ) !== false
      ) {
        this.distinctObj(
          this.$refs.Serialfocusxlh,
          `x_${rowIndex}_y_${index}`
        ).focus();
        this.highlightcurren(rowIndex);
      }
    },
    // 下键
    downArrows(row, rowIndex, index) {
      rowIndex = rowIndex + 1;
      if (
        this.distinctObj(
          this.$refs.Serialfocusxlh,
          `x_${rowIndex}_y_${index}`
        ) !== false
      ) {
        this.distinctObj(
          this.$refs.Serialfocusxlh,
          `x_${rowIndex}_y_${index}`
        ).focus();
        this.highlightcurren(rowIndex);
      }
    },
    // 回车键
    DwArrows(row, rowIndex, index) {
      for (let i = index + 1; i < this.ObtainHeaderxlh.length + 1; i++) {
        if (
          this.distinctObj(
            this.$refs.Serialfocusxlh,
            `x_${rowIndex}_y_${i}`
          ) !== false
        ) {
          this.distinctObj(
            this.$refs.Serialfocusxlh,
            `x_${rowIndex}_y_${i}`
          ).focus();
          return;
        } else if (i + 1 == this.ObtainHeaderxlh.length + 1) {
          rowIndex = rowIndex + 1;
          if (
            this.distinctObj(this.$refs.Serialfocusxlh, `x_${rowIndex}_y_1`) !=
            false
          ) {
            this.distinctObj(
              this.$refs.Serialfocusxlh,
              `x_${rowIndex}_y_1`
            ).focus();
            this.highlightcurren(rowIndex);
          }
        }
      }
    },

    // 滚动条 上移
    highlightcurren(dire) {
      this.$refs.xTable.setCurrentRow(this.tableDataxlh[dire]);
      this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
    },
    // 滚动条 下移
    highlightcurrens(dire) {
      this.$refs.xTable.setCurrentRow(this.tableDataxlh[dire]);
      this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
    },
    // 退出清除数据
    clearData() {
      // 退出前是数据初始化
      this.$emit("update:show", false);
    },
  },
  // 创建生命周期钩子函数
  mounted() {
    // this.switchInit(this.showLeve);
    // this.$refs.xTable.clearSelection();
  },
};
</script>
<style lang="less" scoped>
.el-checkbox {
  margin: 0 0 0 23px;
}
/deep/.el-input--prefix .el-input__inner {
  padding-left: 46px;
}
/deep/ .vxe-table .vxe-body--column:not(.col--ellipsis),
.vxe-table .vxe-footer--column:not(.col--ellipsis),
.vxe-table .vxe-header--column:not(.col--ellipsis) {
  padding: 0;
}
.only_show_div {
  width: 100%;
  height: 100%;
  line-height: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.sty_colls {
  width: 200px;
  box-sizing: border-box;
  margin-right: 37px;
  margin-top: 10px !important;
}
.sty_collsb {
  box-sizing: border-box;
  margin-right: 37px;
  margin-top: 10px !important;
  display: flex;
}

.el-input--medium .el-input__inner {
  height: 30px;
  line-height: 30px;
  border-radius: 0;
}
.btnnimiserial {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}
.btnnimiserials {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.inputserial {
  display: flex;
  // justify-content: center;
  margin-left: 40px;
}
.MaInputg {
  .label_sty {
    color: #333;
    font-size: 12px;
    padding: 0 5px;
    height: 100%;
    line-height: 28px;
    font-weight: bold;
    display: inline-block;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 45px;
  }
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 46px;
}
.vxe-table.t--border.scroll--y .vxe-body--column:last-child,
.vxe-table.t--border.scroll--y .vxe-footer--column:last-child,
.vxe-table.t--border.scroll--y .vxe-header--column:last-child,
.vxe-table.t--border .vxe-body--column,
.vxe-table.t--border .vxe-footer--column,
.vxe-table.t--border .vxe-header--column {
  padding: 0 !important;
}
/deep/ .vxe-table .vxe-cell {
  padding: 0 !important;
}
.input_stt {
  height: 30px;
  width: 100%;
  display: block;
  position: relative;
  -webkit-box-flex: 1;
  box-flex: 1;
  padding: 0 !important;
  background: #fff;
  display: block;
  box-sizing: border-box;
  padding: 0 0;
  border: 0; //可根据需要修改有无边框显示长度和宽带
  overflow: hidden;
  // outline: none;
  text-align: center;
}
.content_btn_box {
  display: -webkit-box !important;
  display: box !important;
  position: relative;
  -webkit-box-align: center;
  box-align: center;
}
#key_content:focus {
  outline: none;
  border: 0;
  border-color: red;
}
.el-dialog__header {
  background: rebeccapurple;
  padding: 10px 10px 0;
  .el-dialog__title {
    color: #fff;
    font-size: 14px;
  }
  .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }
}
/deep/ .vxe-table .vxe-body--column:not(.col--ellipsis),
.vxe-table .vxe-footer--column:not(.col--ellipsis),
.vxe-table .vxe-header--column:not(.col--ellipsis) {
  padding: 0;
}
.el-dialog__body {
  padding: 10px 20px;
}
.SerialTable_box {
  width: 100%;
  height: 50px;
  margin-bottom: 4px;
  /* background-color: aqua; */
  padding: 10px 0;
  // border: 1px solid #dcdfe6;
  border-radius: 5px;
  box-shadow: 0px 0px 7px #ccc;

  h3 {
    text-indent: 20px;
    margin-bottom: 8px;
  }
  .dw {
    margin-left: 20px;
    span {
      margin-left: 180px;
    }
  }
}
.SerialTable_boxs {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.el-tree {
  background: inherit;
}
//滚动条的宽度
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  //   background-color: #a1a3a9;
  //   border-radius: 3px;
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ccc;
}
:-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/SerialTable/SerialTable.vue